import { Model } from '@vuex-orm/core';
import { uuidv4 } from '../../utils/helpers';
import {
  Location, User, CompanyType, Currency, CompanyCompanyType,
} from './models';

export class Company extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'companies';

  static fields() {
    return {
      id: this.attr(() => uuidv4()),
      name: this.attr(null),
      reg_no: this.attr(null),
      vat_no: this.attr(null),
      vat_pct: this.attr(null),
      email: this.attr(null),
      location_id: this.attr(null),
      location: this.belongsTo(Location, 'location_id'),
      currency_code: this.attr(null),
      currency: this.belongsTo(Currency, 'currency_code'),
      types: this.belongsToMany(CompanyType, CompanyCompanyType, 'company_id', 'company_type_code'),
      default_contact_user_id: this.attr(null),
      default_contact_user: this.belongsTo(User, 'default_contact_user_id'),
      users: this.hasMany(User, 'company_id'),
      notes: this.attr(null),
      license_no: this.attr(null),
      updated_at: this.attr(null),
      created_at: this.attr(null),
    };
  }
}

export default Company;
